var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"wizard-item flex items-center btn btn-outlined border font-medium",class:{
    'opacity-10': _vm.disabled,
    'border-black-light': !_vm.active,
    'wizard-item--active btn-secondary': _vm.active,
    'justify-center': _vm.textCenter,
    'text-center': _vm.textCenter
  },attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.onClick}},[(_vm.icon)?_c('img',{staticClass:"mr-2",attrs:{"src":_vm.icon,"alt":"icon","width":"48","height":"48"}}):_vm._e(),_c('span',{staticClass:"wizard-item__text text-black-100 font-normal"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }